const DAY_LABELS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const formatCadence = (cadence: ReportSchedules.Cadence): string => {
  switch (cadence.frequency) {
    case 'daily':
      return `Daily at ${cadence.timeOfDay}`;
    case 'weekly':
      return `Weekly on ${DAY_LABELS[cadence.dayOfWeek ?? 0]} at ${cadence.timeOfDay}`;
    case 'monthly':
      return `Monthly on day ${cadence.dayOfMonth} at ${cadence.timeOfDay}`;
  }
};

export default formatCadence;
